var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveLeads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 42,
    rx: 21,
    fill: "#FEF3F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1039 19.8961L17.5338 26.4663M18.2428 21.698L15.0247 20.9379C14.6706 20.8542 14.5461 20.4147 14.8026 20.1572L17.3619 17.5979C17.5338 17.426 17.767 17.3275 18.0114 17.3257L20.8969 17.3006M24.5314 13.9988C26.679 15.4633 28.5367 17.321 30.0013 19.4686M22.3011 25.7572L23.0613 28.9754C23.1449 29.3294 23.5845 29.454 23.8419 29.1975L26.4012 26.6382C26.5731 26.4663 26.6716 26.233 26.6735 25.9886L26.6985 23.1031M30.5523 17.9585L31.3032 14.3454C31.5077 13.3622 30.6378 12.4924 29.6546 12.6968L26.0415 13.4477C24.9775 13.6689 24.0017 14.1958 23.2341 14.9643L20.2696 17.9278C19.1387 19.0588 18.4027 20.5252 18.1704 22.1078L18.1601 22.1757C18.0133 23.1858 18.3516 24.2053 19.0727 24.9273C19.7938 25.6485 20.8142 25.9867 21.8244 25.839L21.8922 25.8288C23.4748 25.5974 24.9412 24.8604 26.0722 23.7295L29.0357 20.7659C29.8043 19.9983 30.3312 19.0226 30.5523 17.9585Z",
    stroke: "#F97066",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLeads);
export default __webpack_public_path__ + "static/media/activeLeads.b2e570159a93f96eab36969a2698f4d1.svg";
export { ForwardRef as ReactComponent };